module.exports = __webpack_public_path__ + "media/images/admin/icons/users-3b97efeee0fe43d63e620bfd4954ba01.svg";